import type React from 'react';

export type PhoneNumberSource = 'prefill' | 'remembered' | 'autofill' | 'manual';

export function isAutofillChange(event: React.ChangeEvent<HTMLInputElement>): boolean {
  const inputType = (event.nativeEvent as InputEvent).inputType;
  return !inputType || inputType === 'insertReplacementText';
}
